import { Injectable } from '@angular/core';
import { PjesaLigjerates } from '@core/enums/pjesa-ligjerates.enum';
import { PeremriBazaForCreationDTO } from '@core/interfaces/dto/peremri-baza-for-creation-dto.interface';
import { PeremriBazaForUpdateDTO } from '@core/interfaces/dto/peremri-baza-for-update-dto.interface';
import { PeremriBazaParamsDTO } from '@core/interfaces/dto/peremri-baza-params-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { map, throwError } from 'rxjs';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriBazaService {
  private baseUrl: string = '/PeremriBaza';

  constructor(private apiService: ApiService) { }

  getPeremriBaza(params?: PeremriBazaParamsDTO) {
    return this.apiService.get<PeremriBaza[]>(`${PjesaLigjerates.Peremer}${this.baseUrl}`, params);
  }

  getPeremriBazaByBazaId(bazaId: number) {
    return this.apiService.get<PeremriBaza[]>(`${PjesaLigjerates.Emer}${this.baseUrl}`, { bazaId: bazaId }).pipe(
      map((peremriBazat) => {
        if (peremriBazat.length == 0) {
          throw throwError(() => new Error('Not Found'));
        }
        return peremriBazat[0];
      })
    );
  }

  getPeremriBazaById(id: number, params?: { fields: string }) {
    return this.apiService.get<PeremriBaza>(`${PjesaLigjerates.Peremer}${this.baseUrl}/${id}`, params);
  }

  insertPeremriBaza(peremriBaza: PeremriBazaForCreationDTO) {
    return this.apiService.post<PeremriBaza>(`${PjesaLigjerates.Peremer}${this.baseUrl}`, peremriBaza);
  }

  updatePeremriBaza(peremriBaza: PeremriBazaForUpdateDTO) {
    return this.apiService.put<PeremriBaza>(`${PjesaLigjerates.Peremer}${this.baseUrl}`, peremriBaza);
  }

  deletePeremriBaza(id: number) {
    return this.apiService.delete<boolean>(`${PjesaLigjerates.Peremer}${this.baseUrl}`, { id: id });
  }
}
